import React from 'react';
import { Heading, Link, Image, Paragraph, IconSVG, Box } from 'components';
import {
  getArticleSlug,
  estimateReadTime,
  getCloudinaryUrl,
} from 'config/helpers';
import './ArticleBox.scss';

const ArticleBox = ({ post, contributors, color, id }) => {
  const { frontmatter } = post.node;
  const { title, cover, settings, contributor, content } = frontmatter;
  const contributorData = contributors.filter(
    edge => edge.node.frontmatter.title === contributor,
  );

  const articlePureContent = content
    .reduce((a, b) => a.body || a + b.body, '')
    .replace(/[^a-zA-Z ]/g, ' ');

  const readTime = estimateReadTime(articlePureContent);

  return (
    <Box additionalClass={'article-box__wrapper'}>
      <Link id={id} to={getArticleSlug(post)}>
        <div className={`article-box ${color ? `article-box--${color}` : ''}`}>
          <div className={'article-box__top'}>
            <Image
              src={getCloudinaryUrl(cover, 'f_auto,q_auto,h_300')}
              alt={title}
              placeholder
            />
          </div>
          <div className={'article-box__bottom'}>
            <div className={'article-box__info'}>
              <Paragraph
                size={'small'}
                color={'red'}
                additionalClass={'article-box__category text--bold'}
              >
                {settings.category}
              </Paragraph>
              <Paragraph size={'small'} additionalClass={'article-box__time'}>
                {readTime} min read
              </Paragraph>
              <IconSVG name={'time'} color={'black'} />
            </div>
            <div className={'article-box__content'}>
              <Heading type={3} size={'medium'}>
                {title}
              </Heading>
              {contributorData.length > 0 && (
                <div className={'article-box__contributor'}>
                  <Image
                    src={getCloudinaryUrl(
                      contributorData[0].node.frontmatter.photo,
                      'f_auto,q_auto,w_100',
                    )}
                    alt={`${contributorData[0].node.frontmatter.title} avatar`}
                    placeholder
                  />
                  <Paragraph size={'small'}>
                    {contributorData[0].node.frontmatter.title}
                    <br />
                    <span className={'text--light'}>
                      {contributorData[0].node.frontmatter.job}
                    </span>
                  </Paragraph>
                </div>
              )}
            </div>
          </div>
        </div>
      </Link>
    </Box>
  );
};

ArticleBox.defaultProps = {
  color: '',
};

export default ArticleBox;
